import React from 'react';

export default ({ value }) => (
    <span>
        {(Number(value) || 0).toFixed(2)}
        {'\u00A0'}грн
    </span>
);
